// #region Enums
export const enum AdminPages {
  REPORTS = 'reports',
  BALANCE = 'balance',
  TRANSACTIONS = 'transactions',
  USERS = 'users',
  PRICE_LIST = 'price-list',
  PRODUCT_PRICE_LIST = 'product-price-list',
  PACKAGE_MANAGEMENT = 'package-management',
  EXPERTISE_POINT_MANAGEMENT = 'expertise-point-management',
  ANNOUNCEMENT = 'announcement',
  PANEL = 'panel',
  DICTIONARY = 'dictionary',
  MASTER_NOTE = 'master-note',
  INQUIRIES = 'inquiries',
  INHOUSE_CODE = 'inhouse-code',
  FINANCIAL_SUMMARY_REPORT = 'financial-summary-report',
  CAMPAIGN_MANAGEMENT = 'campaign-management',
  CAMPAIGN_MATCHING = 'campaign-matching',
  E_STORE = 'e-store',
}

export const enum AdminReportPages {
  EXPERTISE_PACKAGE = 'expertise-package',
  EXTRA_PACKAGE = 'extra-package',
  SALES = 'sales',
  QUERIES = 'queries',
  CAMPAIGN = 'campaign',
}

// #endregion
export interface AdminUserManagementUser {
  id: number;
  name: string;
  surname: string;
  email: string;
  isAdmin: boolean;
  active: boolean;
  userGroup: number;
}
